import React from 'react';

const InnovationSection = () => {
  return (
    <section className="relative bg-gradient-to-tr from-black to-[#264864] text-white py-20 overflow-hidden">
      <div className="absolute -top-1/4 left-0 w-96 h-96 bg-[#264864]/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-4xl font-bold text-center mb-20">Advanced Innovative IT Company</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-600">
          <div className="flex flex-col items-center justify-center py-8 md:py-0">
            <h3 className="text-4xl font-bold text-cyan-400">150+</h3>
            <p className="text-gray-300 mt-2 text-xl font-bold">clients</p>
          </div>
          <div className="flex flex-col items-center justify-center py-8 md:py-0">
            <h3 className="text-4xl font-bold text-cyan-400">250+</h3>
            <p className="text-gray-300 mt-2 text-xl font-bold">Profiles</p>
          </div>
          <div className="flex flex-col items-center justify-center py-8 md:py-0">
            <h3 className="text-4xl font-bold text-cyan-400">75+</h3>
            <p className="text-gray-300 mt-2 text-xl font-bold">Employees</p>
          </div>
          <div className="flex flex-col items-center justify-center py-8 md:py-0">
            <h3 className="text-4xl font-bold text-cyan-400">2+</h3>
            <p className="text-gray-300 mt-2 text-xl font-bold">Physical Office</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnovationSection;